module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-4-c742f10902c1ec58a471cadcf3e9c6e1.png";